

























  import { defineComponent, ref, onBeforeUnmount, onMounted, SetupContext, nextTick } from 'vue'
  import {
    BrowserMultiFormatReader,
    ChecksumException,
    FormatException,
    NotFoundException,
  } from '@zxing/library'

  export default defineComponent({
    name: 'OneStreamBarcodeReader',
    setup(_, ctx: SetupContext) {
      const localStorageKey = 'StreamBarcodeReaderDeviceId'
      const scanner: any = ref(null)
      const isLoading = ref(true)
      const codeReader = new BrowserMultiFormatReader()
      const canInitScanner = ref(false)
      const videoInputDevices = ref<Array<{ id: string; label: string }>>([])
      const selectedInputDevice = ref<{ id: string; label: string } | null>(null)
      const backCameraKeywords: string[] = [
        'rear',
        'back',
        'rück',
        'arrière',
        'trasera',
        'trás',
        'traseira',
        'posteriore',
        '后面',
        '後面',
        '背面',
        '后置',
        '後置',
        '背置',
        'задней',
        'الخلفية',
        '후',
        'arka',
        'achterzijde',
        'หลัง',
        'baksidan',
        'bagside',
        'sau',
        'bak',
        'tylny',
        'takakamera',
        'belakang',
        'אחורית',
        'πίσω',
        'spate',
        'hátsó',
        'zadní',
        'darrere',
        'zadná',
        'задня',
        'stražnja',
        'belakang',
        'बैक',
      ]
      const checkMediaDevices = async () => {
        if (navigator?.mediaDevices && 'enumerateDevices' in navigator?.mediaDevices) {
          await navigator.mediaDevices
            .getUserMedia({ video: true })
            .then((stream) => {
              stream.getTracks().forEach((track) => {
                track.stop()
              })
              nextTick(() => {
                canInitScanner.value = true
              })
            })
            .catch((error) => {
              console.error('Camera access denied:', error)
              canInitScanner.value = false
            })
        } else {
          canInitScanner.value = false
        }
      }

      const initCameraDevices = async () => {
        await codeReader
          .listVideoInputDevices()
          .then((devices) => {
            if (devices.length > 0) {
              devices.forEach((device) => {
                videoInputDevices.value.push({
                  id: device.deviceId,
                  label: device.label,
                })
              })
              selectDefaultDevice()
            }
          })
          .catch((err) => {
            console.error(err)
          })
      }

      const selectDefaultDevice = () => {
        if (localStorage?.getItem(localStorageKey)) {
          selectedInputDevice.value = videoInputDevices.value.find((device) => {
            return device.id === localStorage.getItem(localStorageKey)
          }) || null
        } else {
          const mainBackCamera = videoInputDevices.value.filter((device) => {
            return backCameraKeywords.some(word => device.label.toLowerCase().includes(word))
          }).sort((camera1, camera2) => {
            return camera1.label.localeCompare(camera2.label)
          })[0]
          if (mainBackCamera) {
            selectedInputDevice.value = mainBackCamera
          } else {
            selectedInputDevice.value = videoInputDevices.value[0]
          }
        }
      }

      onBeforeUnmount(() => {
        codeReader.reset()
      })

      const startScan = (device: { id: string; label?: string } | null = null) => {
        const selectedDevice: string | null = device?.id || selectedInputDevice.value?.id || null
        if (localStorage) {
          selectedDevice ? localStorage.setItem(localStorageKey, selectedDevice) : localStorage.removeItem(localStorageKey)
        }
        codeReader.decodeFromVideoDevice(selectedDevice, scanner.value, (result: any, err) => {
          if (result) {
            ctx.emit('decode', result.text as string)
          }
          if (err) {
            if (err instanceof NotFoundException) {
              console.log('No QR code found.')
            }

            if (err instanceof ChecksumException) {
              console.log("A code was found, but it's read value was not valid.")
            }

            if (err instanceof FormatException) {
              console.log('A code was found, but it was in a invalid format.')
            }
          }
        })
        scanner.value.oncanplay = () => {
          isLoading.value = false
          ctx.emit('loaded')
        }
      }

      onMounted(async () => {
        await checkMediaDevices()
        if (!canInitScanner.value) {
          return
        }
        await initCameraDevices()
        startScan()
      })

      return {
        scanner,
        isLoading,
        codeReader,
        videoInputDevices,
        selectedInputDevice,
        startScan,
      }
    },
  })
